import { useEffect, useState } from 'react';

import { type PreferencesState,preferencesStore } from '@core/preferences/PreferencesStore';

export function usePreferences(): PreferencesState {
  const [state, setState] = useState<PreferencesState>(preferencesStore.getState());

  useEffect(() => {
    const unsubscribe = preferencesStore.subscribe(setState);
    return unsubscribe;
  }, []);

  return state;
}
